// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* 从 center 改为 flex-start */
  justify-content: flex-start; /* 从 center 改为 flex-start */
  height: 100vh;
  background-color: #87CEEB; /* 濕地背景色 */
  position: relative; /* 使子元素可以绝对定位 */
}

.timer, .score {
  font-size: 48px;
  margin-bottom: 10px;
  z-index: 1; /* 确保文字在背景图片之上 */
}

.stars {
  font-size: 48px;
  margin-bottom: 10px;
  z-index: 1; /* 确保文字在背景图片之上 */
  display: none; /* 初始隐藏 */
}

.stars.visible {
  display: block; /* 倒计时结束后显示 */
}

.trash-container {
  position: relative; /* 使子元素可以绝对定位 */
  width: 100%;
  height: 100%;
  z-index: 1; /* 确保垃圾图片在背景图片之上 */
}

.trash-image {
  width: 100px; /* 放大两倍 */
  height: 100px; /* 放大两倍 */
  position: absolute; /* 绝对定位 */
  cursor: pointer;
  transition: opacity 0.5s ease-out; /* 添加淡出效果 */
}

.trash-image.hidden {
  opacity: 0; /* 隐藏图片 */
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0; /* 确保背景图片在最底层 */
}

.start-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px 40px;
  background-color: white;
  border: 2px solid black;
  border-radius: 15px; /* 圆角 */
  font-size: 24px;
  color: black;
  cursor: pointer;
  z-index: 2; /* 确保按钮在最上层 */
}

.congratulations {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 86px;
  color: rgb(249, 35, 35);
  z-index: 2; /* 确保文字在最上层 */
  display: none; /* 初始隐藏 */
}

.congratulations.visible {
  display: block; /* 游戏结束且分数超过100时显示 */
}

.app-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f0f0f0;
}

.game-button {
  margin: 0 20px;
  padding: 20px 40px;
  font-size: 24px;
  font-weight: bold;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,2BAA2B;EACpD,2BAA2B,EAAE,2BAA2B;EACxD,aAAa;EACb,yBAAyB,EAAE,UAAU;EACrC,kBAAkB,EAAE,eAAe;AACrC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,UAAU,EAAE,gBAAgB;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,UAAU,EAAE,gBAAgB;EAC5B,aAAa,EAAE,SAAS;AAC1B;;AAEA;EACE,cAAc,EAAE,aAAa;AAC/B;;AAEA;EACE,kBAAkB,EAAE,eAAe;EACnC,WAAW;EACX,YAAY;EACZ,UAAU,EAAE,kBAAkB;AAChC;;AAEA;EACE,YAAY,EAAE,SAAS;EACvB,aAAa,EAAE,SAAS;EACxB,kBAAkB,EAAE,SAAS;EAC7B,eAAe;EACf,iCAAiC,EAAE,WAAW;AAChD;;AAEA;EACE,UAAU,EAAE,SAAS;AACvB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU,EAAE,eAAe;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB,EAAE,OAAO;EAC5B,eAAe;EACf,YAAY;EACZ,eAAe;EACf,UAAU,EAAE,aAAa;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,uBAAuB;EACvB,UAAU,EAAE,aAAa;EACzB,aAAa,EAAE,SAAS;AAC1B;;AAEA;EACE,cAAc,EAAE,oBAAoB;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start; /* 从 center 改为 flex-start */\n  justify-content: flex-start; /* 从 center 改为 flex-start */\n  height: 100vh;\n  background-color: #87CEEB; /* 濕地背景色 */\n  position: relative; /* 使子元素可以绝对定位 */\n}\n\n.timer, .score {\n  font-size: 48px;\n  margin-bottom: 10px;\n  z-index: 1; /* 确保文字在背景图片之上 */\n}\n\n.stars {\n  font-size: 48px;\n  margin-bottom: 10px;\n  z-index: 1; /* 确保文字在背景图片之上 */\n  display: none; /* 初始隐藏 */\n}\n\n.stars.visible {\n  display: block; /* 倒计时结束后显示 */\n}\n\n.trash-container {\n  position: relative; /* 使子元素可以绝对定位 */\n  width: 100%;\n  height: 100%;\n  z-index: 1; /* 确保垃圾图片在背景图片之上 */\n}\n\n.trash-image {\n  width: 100px; /* 放大两倍 */\n  height: 100px; /* 放大两倍 */\n  position: absolute; /* 绝对定位 */\n  cursor: pointer;\n  transition: opacity 0.5s ease-out; /* 添加淡出效果 */\n}\n\n.trash-image.hidden {\n  opacity: 0; /* 隐藏图片 */\n}\n\n.background-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0; /* 确保背景图片在最底层 */\n}\n\n.start-button {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  padding: 20px 40px;\n  background-color: white;\n  border: 2px solid black;\n  border-radius: 15px; /* 圆角 */\n  font-size: 24px;\n  color: black;\n  cursor: pointer;\n  z-index: 2; /* 确保按钮在最上层 */\n}\n\n.congratulations {\n  position: absolute;\n  top: 40%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 86px;\n  color: rgb(249, 35, 35);\n  z-index: 2; /* 确保文字在最上层 */\n  display: none; /* 初始隐藏 */\n}\n\n.congratulations.visible {\n  display: block; /* 游戏结束且分数超过100时显示 */\n}\n\n.app-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background-color: #f0f0f0;\n}\n\n.game-button {\n  margin: 0 20px;\n  padding: 20px 40px;\n  font-size: 24px;\n  font-weight: bold;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
